// extracted by mini-css-extract-plugin
export default {"tableHeader":"tOKdDPh8KC3CYOiY8WZq","infoCell":"I1_D6GNlBBXBvLYwy40B"};